
export default {
  head() {
    return {
      title:
        "Agence Google Ads | SEA en Centre-Val de Loire dès 290€/mois - ALEO AGENCY",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "ALEO, agence Google Ads en Centre-Val de Loire certifiée Google Partner, accompagne les entreprises régionales pour accroître leur visibilité en ligne et attirer des prospects qualifiés.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content:
            "Agence Google Ads en Centre-Val de Loire dès 290€/mois - ALEO AGENCY",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "ALEO, agence Google Ads en Centre-Val de Loire certifiée Google Partner, accompagne les entreprises régionales pour accroître leur visibilité en ligne et attirer des prospects qualifiés.",
        },
      ],
    };
  },
};
